import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { EmptyStateMessageContainer, EmptyStateMessageSubtitle, EmptyStateMessageTitle } from "./styles";

export const EmptyColumnOptionListMessage = () => {
    const translate = useTranslation();

    return (
        <EmptyStateMessageContainer>
            <EmptyStateMessageTitle>
                {translate("si.components.advanced_search_results_table.column_picker.empty_state_title")}
            </EmptyStateMessageTitle>
            <EmptyStateMessageSubtitle>
                {translate("si.components.advanced_search_results_table.column_picker.empty_state_subtitle")}
            </EmptyStateMessageSubtitle>
        </EmptyStateMessageContainer>
    );
};
